module.exports = __webpack_public_path__ + "static/media/mercury.20be1799.png";